import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

export interface SigadPreviewData {
  titulo: string
  urlPdf: string
  mostrarEnvio?: boolean
  mostrarDownload?: boolean
}

@Component({
  selector: 'app-sigad-preview-dialog',
  templateUrl: './sigad-preview-dialog.component.html',
  styleUrls: ['./sigad-preview-dialog.component.css'],
})
export class SigadPreviewDialogComponent implements OnInit, OnDestroy {
  pdfBlob: Blob | null = null
  private blobUrl: string | null = null

  loading = true
  erro = false
  pdfReady = false
  isFullscreen = false
  private get isPreview(): boolean { return this.data.mostrarDownload === false }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): void {
    if (this.isPreview && (e.ctrlKey || e.metaKey) && ['p', 's'].includes(e.key.toLowerCase())) {
      e.preventDefault()
      e.stopImmediatePropagation()
    }
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(e: MouseEvent): void {
    if (this.isPreview) e.preventDefault()
  }

  @HostListener('document:fullscreenchange')
  onFullscreenChange(): void {
    this.isFullscreen = !!document.fullscreenElement
  }

  constructor(
    private el: ElementRef,
    public dialogRef: MatDialogRef<SigadPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SigadPreviewData
  ) {}

  ngOnInit(): void {
    this.carregarPdf()
  }

  toggleFullscreen(): void {
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {})
    } else {
      this.el.nativeElement.requestFullscreen().catch(() => {})
    }
  }

  private carregarPdf(): void {
    const token = localStorage.getItem('access_token') || ''
    if (!token) {
      this.erro = true
      this.loading = false
      return
    }

    fetch(this.data.urlPdf, {
      headers: { Authorization: `Bearer ${token}` },
      credentials: 'include',
    })
      .then(response => {
        if (!response.ok) throw new Error(`Erro: ${response.status}`)
        return response.blob()
      })
      .then(blob => {
        this.pdfBlob = blob
        this.blobUrl = URL.createObjectURL(blob)
        this.loading = false
        setTimeout(() => this.pdfReady = true)
      })
      .catch(() => {
        this.erro = true
        this.loading = false
      })
  }

  download(): void {
    if (!this.blobUrl) return
    const link = document.createElement('a')
    link.href = this.blobUrl
    link.download = this.data.titulo + '.pdf'
    link.click()
  }

  confirmar(): void {
    this.dialogRef.close(true)
  }

  cancelar(): void {
    this.dialogRef.close(false)
  }

  ngOnDestroy(): void {
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {})
    }
    if (this.blobUrl) URL.revokeObjectURL(this.blobUrl)
  }
}
